export var EMPTY_BREAKPOINT = {
    breakpoint: undefined,
    minWidth: undefined,
    maxWidth: undefined,
};
